module.exports = __webpack_public_path__ + "img/logoicon.c97dced7.svg";